export default "__VITE_ASSET__bf4uMwVJ__"